import { Routes, Route } from "react-router-dom";
import "antd/dist/antd.less";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import PMS from "./consts/permissions";

import Home from "./pages/Home";

import SignIn from "./pages/SignIn";

import UserCustomer from "./pages/UserCustomer";
import UserSystem from "./pages/UserSystem";
import RoleManager from "./pages/RoleManager";

import Product from "./pages/Product/Product";
import ProductAdd from "./pages/Product/ProductAdd";
import ProductCategory from "./pages/Product/ProductCategory";
import ProductEdit from "./pages/Product/ProductEdit";

import Article from "./pages/Article/Article";
import ArticleAdd from "./pages/Article/ArticleAdd";
import ArticleCategory from "./pages/Article/ArticleCategory";
import ArticleEdit from "./pages/Article/ArticleEdit";

import Main from "./components/layout/Main";
import Unauthorized from "./components/layout/Unauthorized";
import RequireAuth from "./components/layout/RequireAuth";
import Missing from "./components/layout/Missing";
import ShippingManager from "./pages/ShippingManager";
import Payments from "./pages/Modules/Payments";
import Newspapers from "./pages/Modules/Newspapers";
import Order from "./pages/Order/Order";
import OrderDetails from "./pages/Order/OrderDetails";
import OrderAdd from "./pages/Order/OrderAdd.js";

import AdsProducts from "./pages/Modules/AdsProducts";
import SeoModules from "./pages/SeoPages/Index";
import HomeModules from "./pages/Modules/Home";
import PageAdd from "./pages/Page/PageAdd";
import PageEdit from "./pages/Page/PageEdit";

import FileManager from "./pages/FileManager";
import UploadFile from "./components/UploadFile";
import Page from "./pages/Page";
import Footer from "./pages/Footer";
import Header from "./pages/Header";

import Test from "./pages/Test";
import ProductIframe from "./pages/ProductIframe";
import Voucher from "./pages/Voucher";
import Promotion from "./pages/Promotion";

import Info from "./pages/Info";
import Dealer from "./pages/Dealer";
import Reviews from "./pages/Review/Reviews";
import DetailsReview from "./pages/Review/DetailsReview";

import Reports from "./pages/Reports";
import Sitemap from "./pages/Sitemap";
import LogsTransaction from "./pages/LogsTransaction";


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="sign-in" element={<SignIn />} />
        <Route path="product-iframe/:id" element={<ProductIframe />} />

        <Route path="/" element={<SignIn />} />
        <Route path="unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Missing />} />

        <Route path="/*" element={<Main />}>
          <Route path="dashboard" element={<Home />} />

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_UserSystem_View} />}
          >
            <Route path="user-system" element={<UserSystem />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Role_View} />}>
            <Route path="role-manager" element={<RoleManager />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_UserCustomer_View} />}
          >
            <Route path="user-customer" element={<UserCustomer />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Product_View} />}>
            <Route path="product" element={<Product />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_Product_Create} />}
          >
            <Route path="product/add" element={<ProductAdd />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_Product_Update} />}
          >
            <Route path="product/edit/:id" element={<ProductEdit />} />
          </Route>

          <Route
            element={
              <RequireAuth allowedPer={PMS.Admin_ProductCategory_View} />
            }
          >
            <Route path="product-category" element={<ProductCategory />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Blog_View} />}>
            <Route path="article" element={<Article />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Blog_Create} />}>
            <Route path="article/add" element={<ArticleAdd />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Blog_Update} />}>
            <Route path="article/edit/:id" element={<ArticleEdit />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_BlogCategory_View} />}
          >
            <Route path="article-category" element={<ArticleCategory />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_BlogCategory_View} />}
          >
            <Route path="article-category" element={<ArticleCategory />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Shipping_View} />}>
            <Route path="shipping" element={<ShippingManager />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_Newspapers_View} />}
          >
            <Route path="newspapers" element={<Newspapers />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Page_View} />}>
            <Route path="page" element={<Page />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Page_Create} />}>
            <Route path="page/add" element={<PageAdd />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Page_Update} />}>
            <Route path="page/edit/:id" element={<PageEdit />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Voucher_View} />}>
            <Route path="voucher" element={<Voucher />} />
          </Route>

          <Route
            element={<RequireAuth allowedPer={PMS.Admin_Promotion_View} />}
          >
            <Route path="promotion" element={<Promotion />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Setting_View} />}>
            <Route path="home-modules" element={<HomeModules />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Setting_View} />}>
            <Route path="seo-modules" element={<SeoModules />} />
          </Route>

          <Route element={<RequireAuth allowedPer={PMS.Admin_Transaction_View} />}>
            <Route path="logs" element={<LogsTransaction />} />
          </Route>


          <Route path="payments" element={<Payments />} />

          <Route path="order" element={<Order />} />
          <Route path="order/add" element={<OrderAdd />} />
          <Route path="order/:id" element={<OrderDetails />} />

          <Route path="ads" element={<AdsProducts />} />

          <Route path="footer" element={<Footer />} />
          <Route path="header" element={<Header />} />
          <Route path="info" element={<Info />} />
          <Route path="dealer" element={<Dealer />} />
          <Route path="review" element={<Reviews />} />
          <Route path="review/:id" element={<DetailsReview />} />

          <Route path="reports" element={<Reports />} />

          <Route path="test" element={<Test />} />
          <Route path="uploadFile" element={<UploadFile />} />
          <Route path="file-manager" element={<FileManager />} />
          <Route path="sitemap" element={<Sitemap />} />


          {/* <Redirect from="*" to="/dashboard" element={<Home />} /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
